/**
 *  Classe especifica para gerenciamento das tags de equipamento no mapa
 *
 * @author: Daniel Laurindo
 * Date: 16/12/13
 * Time: 14:00
 */



Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.Map = Greenmile.Toolbar.Map || {};
Greenmile.Toolbar.Map.TagsEquipmentActions = Greenmile.Toolbar.Map.TagsEquipmentActions || {};

Greenmile.Toolbar.Map.TagsEquipmentActions = function (map, selector) {

    var criteria = {};
    const storeMapPosition = new Greenmile.Storage.StoreMapPosition();

    this.entity = 'Tag';

    this.selector = selector;

    this.classSelector = 'tagsEquipment';

    this.updateTag = function(tag) {

        var found = Monet.Session.TagList.Equipment.filter(function(t){
            return tag.id == t.id;
        })[0];

        if( found ) {

            if(found.description !== tag.description ||
                found.enabled !== tag.enabled ||
                found.tagColor !== tag.tagColor
            ) {
                found.description = tag.description;
                found.enabled = tag.enabled;
                found.tagColor = tag.tagColor;
            }

        } else {
            Monet.Session.TagList.Equipment.push(tag);
        }

    };

    this.removeTag = (list) => {
        Monet.Session.TagList.Equipment.forEach(function(oldTag, index, tags) {
            var found = list.filter(function(tag){
                return oldTag.id == tag.id;
            })[0];

            if(!found) {
                tags.splice(index, 1);
            }
        });
    };

    this.requestTags = (callback) => {

        let tags = [];
        const ajax = new Monet.Ajax();
        ajax.url = `${this.entity}/restrictions?criteria={"filters":[ "id", "description" ]}`;
        ajax.method = 'POST';
        ajax.data = '{"criteriaChain":[{"and":[{"attr":"tagType","eq":"EQUIPMENT"}]}],"sort":[{"attr":"description","type":"ASC"}]}';

        ajax.success = (tags) => {
            if (tags) {
                Monet.Session.TagList = Monet.Session.TagList || {};
                Monet.Session.TagList.Equipment = tags;

                var existInLocalStorage = storeMapPosition.getEquipmentTagFromUser();
                if (!existInLocalStorage) {
                    var equipmentsToLocalStorage = storeMapPosition.createListEquipmentTags();
                    storeMapPosition.setEquipmentTagFromUser(equipmentsToLocalStorage);
                } else {
                    storeMapPosition.checkEquipmentsOnLocalStorage();
                }

                if(callback) {
                    callback(tags);
                }
            }
        };

        ajax.error = (responseText) => {
            this.showErrorExceptionOnTagEquipment(responseText);
        };

        ajax.send();

        return tags;
    };

    this.showErrorExceptionOnTagEquipment = (responseText) => {
        console.error(responseText);
    };

    this.setSelector = (selector) => this.selector = selector;

    this.getSelector = () => this.selector || '';

    this.getTextSelector = () => this.selector ? this.selector.replace(/[^0-9a-z]/gi, '') : '';

    this.appendTextSelector = () => this.selector ? this.getTextSelector() + '-' : '';

    this.getListTags = (callback) => ( this.requestTags(callback) ) ;

    this.getOptionSelected = () => storeMapPosition.getEquipmentsTagsMarked() ;

    this.markCheckBox = (equipmentsMarked) => {
        for (var j = 0, sizeEqLS = equipmentsMarked.length; j < sizeEqLS; j++) {
            $("#EQUIPMENT-" + this.appendTextSelector() + equipmentsMarked[j].id).prop("checked", true);
        }
    };

    this.makeAction = () => {

        var checked = document.querySelectorAll('.tagsEquipment input[type="checkbox"]:checked'),
            id      = null;

        var hasEnabledTags = checked.length > 0;

        criteria.criteriaChain = [];

        if (hasEnabledTags) {

            criteria.criteriaChain.push({ or: [] });

            for (var i = 0; i < checked.length; i++) {

                id = checked[i].id.replace("EQUIPMENT-" + this.appendTextSelector(), "");
                this.builderCriteria(id);
            }
        } else {
            checked = null;
        }

        storeMapPosition.updateEquipmentTags(checked, this.getTextSelector());

        App.Objects.RouteMonitor.getEquipmentPositionsByOrganizations();
    };

    this.builderCriteria = (id) => {

        criteria.criteriaChain[0].or.push({
            eq: id,
            attr: 'tags.id'
        });

    };

    this.addListeners = () => {

        const listCheckbox = document.querySelectorAll('.tagsEquipment');
        const selectAllCheckbox = document.getElementById(`${this.getTextSelector()}-${this.classSelector}-selectAll`);

        selectAllCheckbox.addEventListener("change", (ev) => {
            for (let i = 0; i < listCheckbox.length; i++) {
                listCheckbox[i].checked = ev.target.checked;
            }
            this.makeAction();
        });

        for (var i = 1; i < listCheckbox.length; i++) {
            listCheckbox[i].addEventListener("change", () => {
                this.makeAction();
                this._verifyCheckSelectAll();
            });
        }
        this._verifyCheckSelectAll();
    };

    this._verifyCheckSelectAll = () => {
        const selectAllCheckbox = document.getElementById(`${this.getTextSelector()}-${this.classSelector}-selectAll`);
        const allCheckboxCount = document.querySelectorAll(this.getSelector() + ' .tagsContainer.tagsEquipment input[type="checkbox"].' + this.classSelector).length;
        const selectedCheckboxCount = document.querySelectorAll(this.getSelector() + ' .tagsContainer.tagsEquipment input[type="checkbox"]:checked.' + this.classSelector).length;

        if (selectedCheckboxCount < allCheckboxCount) {
            selectAllCheckbox.checked = false;
        } else {
            selectAllCheckbox.checked = true;
        }
    }

};